import React from 'react';
import { Image, Stack, Text } from '@mantine/core';

import { PopupEventVendorDetailsUpcoming } from '../types';

type PopupUpcomingMealProps = {
  event: PopupEventVendorDetailsUpcoming;
};

const PopupUpcomingMeal: React.FC<PopupUpcomingMealProps> = ({
  event: { menuTemplate, mealPrep },
}) => (
  <>
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Text>Menu to bring:</Text>
      <Text c="dimmed">{menuTemplate.name}</Text>
    </Stack>
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Image maw="5rem" src="/assets/images/fooda_ai_logo.png" />
      <Text>
        Meal Prep: <strong>{mealPrep?.prepFor ?? 0}</strong>
      </Text>
    </Stack>
  </>
);

export default PopupUpcomingMeal;
